import store from './store'
import { DLP } from '../modulesNames'
import { ACT_SEND_SCREENSHOT_EVENT } from '../actionsTypes'

window.addEventListener('keyup', (e) => {
    if (e.key == 'PrintScreen') {
        store.dispatch(`${DLP}/${ACT_SEND_SCREENSHOT_EVENT}`)
    }
})